import { createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-3fbefc67"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "axero-widget axero-sub-widget axero-tag-filter tl-tag-filter" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "axero-widget-header" }, [
  /*#__PURE__*/_createElementVNode("h3", null, "Tags")
], -1 /* HOISTED */))
const _hoisted_3 = { class: "axero-widget-content axero-tag-cloud" }
const _hoisted_4 = ["onClick"]
const _hoisted_5 = { class: "tags" }
const _hoisted_6 = ["href"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _hoisted_2,
    _createElementVNode("div", _hoisted_3, [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.tagGroups, (tagGroup) => {
        return (_openBlock(), _createElementBlock("div", {
          key: tagGroup.TagGroupID,
          class: _normalizeClass(["tag-group", { 'open': tagGroup.isOpen }])
        }, [
          _createElementVNode("div", {
            class: "tag-group-header",
            onClick: ($event: any) => {tagGroup.isOpen = !tagGroup.isOpen;}
          }, _toDisplayString(tagGroup.TagGroupName), 9 /* TEXT, PROPS */, _hoisted_4),
          _createElementVNode("ul", _hoisted_5, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(tagGroup.Tags, (tag) => {
              return (_openBlock(), _createElementBlock("li", {
                key: tag.TagID
              }, [
                _createElementVNode("a", {
                  class: _normalizeClass([{ 'tag-filter-on': tag.isActive }, "label"]),
                  href: tag.href
                }, _toDisplayString(tag.displayName), 11 /* TEXT, CLASS, PROPS */, _hoisted_6)
              ]))
            }), 128 /* KEYED_FRAGMENT */))
          ])
        ], 2 /* CLASS */))
      }), 128 /* KEYED_FRAGMENT */))
    ])
  ]))
}